module.exports = __webpack_public_path__ + "static/media/logo.18555f8e.png";